module.exports = __webpack_public_path__ + "static/img/upload_icon.dbac2cc3.png";